import React from 'react';

const CustomSVG = ({ fillColor = "#f6b5d3", flipped = false, children }) => (
    <div style={{ position: 'relative', width: '200px', height: '100px' }}>
        {/* SVG с возможностью отражения */}
        <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 926.55 494.61"
            width="200"
            height="100"
            style={{ transform: flipped ? 'scaleX(-1)' : 'none' }} // Отражаем только SVG
        >
            <defs>
                <style>
                    {`.cls-1 { fill: ${fillColor}; }`}
                </style>
            </defs>
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    className="cls-1"
                    d="M926.55,247.31c0,135.53-109.03,245.6-244.17,247.28-1.05.01-2.09.02-3.14.02H0V0h679.24c1.05,0,2.09.01,3.14.02,135.14,1.68,244.17,111.75,244.17,247.29Z"
                />
            </g>
        </svg>
        {/* Текст поверх SVG */}
        <div
            className="customSVG"
        >
            {children}
        </div>
    </div>
);

export default CustomSVG;